export default __webpack_public_path__ + "static/media/waiter.409b708e.gif";